import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "t2-main" }
const _hoisted_2 = { class: "t2-content" }
const _hoisted_3 = { class: "container mar_b" }
const _hoisted_4 = { style: {"font-size":"20px","font-weight":"600","text-align":"center"} }
const _hoisted_5 = { style: {"text-align":"center","padding":"20px 0 10px","border-bottom":"1px solid #eee"} }
const _hoisted_6 = { style: {"margin-left":"40px"} }
const _hoisted_7 = ["srcdoc"]

import { getNewsContentList } from '@/config/request'
import { ref } from 'vue'
import { useRoute, useRouter } from 'vue-router'


export default /*@__PURE__*/_defineComponent({
  __name: 'friendly-news-detail',
  setup(__props) {

const route = useRoute()
const router = useRouter()
const id = route.query.id
let detail = ref({}) as any
let showContent = ref(false)
const init = async() => {
    const param = {
        id: id
    }
    const res = await getNewsContentList(param) as any
    detail.value = res.result?.records[0] || {}
    if(detail.value.isLink === 'Y'){
        let link = ''
        let str = detail.value.releaseContent
        let res = str.match(/href=\"(\S*)\"/)
        if(res){
            link = res[1]
        }
        router.back()
        window.open(link)
    }else{
        showContent.value = true
    }
}
init()


return (_ctx: any,_cache: any) => {
  const _component_Top = _resolveComponent("Top")!
  const _component_Bottom = _resolveComponent("Bottom")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_unref(showContent))
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _createVNode(_component_Top, { fixedNobanner: true }),
          _cache[1] || (_cache[1] = _createElementVNode("div", {
            class: "no_banner",
            id: "no_banner"
          }, null, -1)),
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _cache[0] || (_cache[0] = _createElementVNode("div", { class: "t6_breadCream" }, [
                  _createElementVNode("span", null, "污染防治"),
                  _createTextVNode(),
                  _createElementVNode("i", null, ">"),
                  _createElementVNode("span", null, "详情页面")
                ], -1)),
                _createElementVNode("div", _hoisted_4, _toDisplayString(_unref(detail).title), 1),
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("span", null, "发布时间：" + _toDisplayString(_unref(detail).releaseDate), 1),
                  _createElementVNode("span", _hoisted_6, "分类：" + _toDisplayString(_unref(detail).typeName || _unref(detail).themeId_dictText), 1)
                ]),
                _createElementVNode("iframe", {
                  width: "100%",
                  name: "newContentIframe",
                  onload: "this.height=newContentIframe.document.body.scrollHeight * 1.05 + 100",
                  frameborder: "0",
                  scrolling: "no",
                  tabindex: "1",
                  srcdoc: _unref(detail).releaseContent
                }, null, 8, _hoisted_7)
              ])
            ])
          ])
        ], 64))
      : _createCommentVNode("", true),
    _createVNode(_component_Bottom)
  ], 64))
}
}

})